import React from 'react';
import { Link } from 'react-router-dom';

const SmallNewsCard = ({ id, image, title }) => {
  return (
    <Link to={`/news/${id}`} className="group flex flex-col h-full border border-gray-200/70 rounded-xl p-3 bg-white hover:border-gray-300 hover:shadow-sm transition-all duration-300">
      <div className="w-full aspect-[3/2] rounded-md overflow-hidden bg-gray-100 mb-2.5">
        <img 
          src={image} 
          alt={title} 
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" 
        />
      </div>
      
      <div className="flex flex-col flex-1">
        <h4 className="text-gray-900 font-normal text-[13px] md:text-[14px] leading-snug line-clamp-3 group-hover:text-brand-red transition-colors">
          {title}
        </h4>
        
        {/* Interactive Action Bar (Video, Sound, Share, More) */}
        <div className="mt-auto pt-3 pb-1 border-t border-gray-100/60 flex justify-between items-center opacity-80 group-hover:opacity-100 transition-opacity">
          <div className="flex gap-3.5">
            <button className="text-red-500 hover:text-red-600 transition transform hover:scale-110" title="वीडियो चलाएं">
              <i className="fa-solid fa-circle-play text-[15px]"></i>
            </button>
            <button className="text-blue-500 hover:text-blue-600 transition transform hover:scale-110" title="ध्वनि">
              <i className="fa-solid fa-volume-high text-[14px]"></i>
            </button>
          </div>
          <div className="flex gap-3.5">
            <button className="text-green-500 hover:text-green-600 transition transform hover:scale-110" title="साझा करें">
              <i className="fa-solid fa-share-nodes text-[14px]"></i>
            </button>
            <button className="text-gray-400 hover:text-gray-600 transition transform hover:scale-110" title="अधिक">
              <i className="fa-solid fa-ellipsis-vertical text-[14px]"></i>
            </button>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default SmallNewsCard;
